export const moveTo = "IpM4Hc";
export default {moveTo};